'use client';

import { c as _c } from "react/compiler-runtime";
import { leagueTiers } from './_data';
export function LeagueTiers() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mb-8 grid gap-6 lg:grid-cols-[0.8fr_1.2fr]"><div><h2 className="font-sans text-5xl font-semibold">Three neighborhoods, one league, zero peace.</h2></div><p className="text-lg leading-8 font-semibold text-[#5f5364]">The points-versus-table plot looks polite, but the clusters are not subtle. Rohit and Teddy are uptown. Eight teams are stuck arguing in the middle. Hookah and Shyam are in the basement having a separate conversation lower down.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="fantasy-reveal mx-auto max-w-7xl px-5 py-16 sm:px-8">{t0}<div className="grid gap-4 md:grid-cols-2">{leagueTiers.map(_temp)}</div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(tier) {
  return <article key={tier.tier} className="border border-[#d7c9b7] bg-[#fffaf1] p-5"><p className="text-xs font-black text-[#8a3f31] uppercase">{tier.tier}</p><h3 className="mt-2 font-sans text-3xl font-semibold">{tier.teams}</h3><p className="mt-4 text-sm leading-6 font-semibold text-[#514458]">{tier.body}</p></article>;
}